const SPACING_DEFAULT = 0.5;

export GlobalReset from './global-reset';

const deviceSizes = {
  s: '414px',
  m: '834px',
  l: '1024px',
};

export const theme = {
  deviceSizes,

  device: {
    s: `(min-width: ${deviceSizes.s})`,
    m: `(min-width: ${deviceSizes.m})`,
    l: `(min-width: ${deviceSizes.l})`,
  },

  colors: {
    brand: '#DB4646',
    accent: '#5B46DB',
    bodyFg: '#000000',
    accentFg: '#FFFFFF',
    outline: '#DBDBDB',
  },

  fonts: {
    main: 'effra, arial, sans-serif',
    heading: 'fatfrank, arial, sans-serif',
  },

  fontSizes: {
    heading1: '44px',
    heading2: '38px',
    heading3: '30px',
    heading4: '26px',
    heading5: '24px',
    heading6: '20px',
    paragraph: '20px',
    legal: '16px',
  },

  spacingBase: `${SPACING_DEFAULT}em`,
  spacingHalf: `${SPACING_DEFAULT / 2}em`,
  spacingTriple: `${SPACING_DEFAULT * 3}em`,
  spacingQuadruple: `${SPACING_DEFAULT * 4}em`,
  spacingDouble: `${SPACING_DEFAULT * 2}em`,

  grid: {
    maxWidth: `1024px`,
  },

  background: {
    primary: '#fafaf9',
    secondary: '#3a303a',
  },
  accent: {
    primary: '#88a4a2',
    secondary: '#7c7d7a',
  },
  brand: '#bec628',
};
